import NotFoundComponent from "@/components/notfound";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="p-20">
      <NotFoundComponent>
        <Button variant="secondary" onClick={() => navigate("/dualSTAKE")}>
          <Home /> Back to Home
        </Button>
      </NotFoundComponent>
    </div>
  );
}
